import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  EmptyItemExtension,
  IItem,
  IModalVisible,
  IProject,
} from 'utils/types/storyTypes';
import { useAppDispatch } from 'hooks/redux';
import {
  queryLocalizedCodeList,
  queryProjectCodeList,
} from 'apis/common/commonApis';
import { useCookies } from 'react-cookie';
import { setEditName } from 'store/slices/breadcumbSlice';
import DefaultLayout from 'components/layout/DefaultLayout';
import InputFlexBox from 'components/container/InputFlexBox';
import { Checkbox } from 'antd';
import InputWrappingBox from 'components/container/InputWrappingBox';
import { theme } from 'utils/style/theme';
import SelectBox from 'components/SelectBox';
import { useTranslation } from 'react-i18next';
import InputStyled from 'components/InputStyled';
import RangeDatepickerStyled from 'components/RangeDatepickerStyled';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import PrimaryButton from 'components/button/PrimaryButton';
import UploadSingleImage from 'components/ImageUploader/UploadSingleImage';
import TwoColumnLocalizeSupporter from 'components/LocalizeSupportTable/TwoColumLocalizeSuppporter';
import { itemApis } from 'apis/package/itemApis';
import {
  showApiErrorMessage,
  showApiSuccessMessage,
} from 'utils/helper/message';
import InputWithCounter from 'components/input/InputWithCounter';

// * 파라매터로 받지 않고, location으로 받는다.
const ItemEdit: React.FC = () => {
  const { t } = useTranslation();
  const { projectId } = useParams(); // id: 프로젝트 id
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [cookies] = useCookies();

  const [visibleState, setVisibleState] = useState<IModalVisible>({
    create: false,
    edit: false,
  });

  const location = useLocation();
  const currentItem = location.state.currentItem as IItem;
  // const currentProject = location.state.currentProject as IProject;

  const [itemData, setItemData] = useState<IItem>(currentItem); // 아이템 정보

  const { isLoading: isLoadingItemType, data: dropdownItemType } =
    queryLocalizedCodeList('item_type', cookies.lang);
  const { isLoading: isLoadingSaleType, data: dropdownSaleType } =
    queryLocalizedCodeList('sale_type', cookies.lang);

  // const dropdownAbility = queryProjectAbilityList(projectId); // 프로젝트 능력 리스트
  const { isLoading: isLoadingBgList, data: dropdownBG } = queryProjectCodeList(
    projectId,
    'bg',
  );
  const { isLoading: isLoadingMinicutList, data: dropdownMinicut } =
    queryProjectCodeList(projectId, 'minicut');
  const { isLoading: isLoadingModelList, data: dropdownModel } =
    queryProjectCodeList(projectId, 'model'); // 프로젝트 모델리스트

  const { isLoading: isLoadingAbility, data: dropdownAbility } =
    queryProjectCodeList(projectId, 'ability'); // 프로젝트 능력 리스트

  // * useEffect
  useEffect(() => {
    console.log(`ItemEdit : `, itemData);
    // console.log(`ItemEdit dropdownsaleType : `, dropdownsaleType);

    dispatch(setEditName(itemData.origin_name));

    // setItemData(currentItem);
  }, [itemData]);

  const submit = async () => {
    try {
      await itemApis.itemUpdate(projectId, itemData.id, itemData);
      showApiSuccessMessage('아이템 정보가 저장되었습니다');
    } catch (err) {
      showApiErrorMessage(err);
    }
  };

  const onClickCancel = () => {
    navigate(-1);
  };

  const onChangeGeneralValue = (value, data_column: string) => {
    const cloneData = structuredClone(itemData);
    if (!cloneData.extension) {
      cloneData.extension = EmptyItemExtension;
    }

    if (data_column == 'item_type') {
      cloneData.item_type = value;

      // 유형에 따라 일부 항목 자동 제어
      if (value == 'gift') {
        // 선물템
        cloneData.is_unique = false;
        cloneData.is_consumable = true;
        cloneData.is_prime = false;
      } else if (value == 'key') {
        // 스토리 키 아이템
        cloneData.is_unique = true;
        cloneData.is_consumable = false;
        cloneData.is_prime = false;
      } else if (value == 'standing') {
        // 의상
        cloneData.is_unique = true;
        cloneData.is_consumable = false;
        cloneData.is_prime = false;
      } else if (value == 'consumable') {
        // 화폐
        cloneData.is_unique = false;
        cloneData.is_consumable = true;
      }
    } else if (data_column == 'is_unique') cloneData.is_unique = value;
    else if (data_column == 'is_consumable') cloneData.is_consumable = value;
    else if (data_column == 'is_prime') cloneData.is_prime = value;
    else if (data_column == 'resource_id') cloneData.resource_id = value;
    else if (data_column == 'ability_id') cloneData.ability_id = value;
    else if (data_column == 'ability_value') cloneData.ability_value = value;
    //extension
    else if (data_column == 'product_type')
      cloneData.extension.product_type = value;
    else if (data_column == 'price') cloneData.extension.price = value;
    else if (data_column == 'sale_price')
      cloneData.extension.sale_price = value;
    else if (data_column == 'static_id') cloneData.extension.static_id = value;
    else if (data_column == 'is_public') cloneData.extension.is_public = value;

    setItemData(cloneData);
  };

  // Date Picker 값 변경
  const onChangeDatePicker = (dateString) => {
    const cloneData = structuredClone(itemData);
    const newStartDate = new Date(dateString[0]);
    const newEndDate = new Date(dateString[1]);
    const formattedStartDate = newStartDate.toISOString();
    const formattedEndDate = newEndDate.toISOString();

    if (!cloneData.extension) cloneData.extension = EmptyItemExtension;

    cloneData.extension.sale_start_date = new Date(formattedStartDate);
    cloneData.extension.sale_end_date = new Date(formattedEndDate);

    // if (cloneData.extension) {
    //   cloneData.extension.sale_start_date = formattedStartDate;
    //   cloneData.extension.sale_end_date = formattedEndDate;
    //   setData(cloneData);
    // } else {
    //   cloneData.extension = {};
    //   cloneData.extension.sale_start_date = formattedStartDate;
    //   cloneData.extension.sale_end_date = formattedEndDate;
    //   setData(cloneData);
    // }

    setItemData(cloneData);
  };

  if (
    isLoadingSaleType ||
    isLoadingItemType ||
    isLoadingBgList ||
    isLoadingModelList ||
    isLoadingAbility ||
    isLoadingMinicutList
  )
    return <>Loading...</>;

  // console.log(dropdownAbility);

  // ! RETURN
  return (
    <>
      {/* 디폴트 Layout 유지하면서 InputFlexBox로 감싼다 */}
      <DefaultLayout>
        <Wrapper>
          <InputFlexBox>
            {/* 왼쪽 구역 */}
            <LeftSide>
              <SectionWarpper>
                <p className='edit-heavy-title'>{`게임 아이템 기본 정보 (ID : ${itemData.id})`}</p>
                <div>
                  <p className='title'>
                    아이템 이름(스크립트에서 사용되는 이름)
                  </p>
                  <InputWithCounter
                    value={itemData.origin_name}
                    disabled={true}
                  />
                </div>

                <div>
                  <p className='title'>다국어 적용 아이템 이름</p>
                  {/* 다국어 지원 테이블 (2컬럼) */}
                  <TwoColumnLocalizeSupporter
                    targetData={itemData}
                    setTargetData={setItemData}
                    visibleState={visibleState}
                    setVisibleState={setVisibleState}
                    currentLocalDataArray={itemData.localizations}
                    columnName={'아이템 이름'}
                    targetLocalize='item'
                  />
                </div>

                {/* 아이템 유형 */}
                <div>
                  <p className='title'>
                    {t(
                      'storyEpisodeID.storyTabMenuList.operationContent.editPage.itemType',
                    )}
                    :
                  </p>
                  <SelectBox
                    value={itemData?.item_type}
                    onChange={(e) => {
                      onChangeGeneralValue(e, 'item_type');
                    }}
                    options={dropdownItemType?.map((v, i) => {
                      return {
                        value: v.code,
                        label: v.code_name,
                      };
                    })}
                  />
                </div>
              </SectionWarpper>
              {/* 체크박스 영역 */}
              <CheckboxSection>
                <CheckboxWrapper>
                  <p className='title'>중복 보유 불가 :</p>
                  <CheckboxStyled
                    checked={itemData?.is_unique}
                    onChange={(e) => {
                      onChangeGeneralValue(e.target.checked, 'is_unique');
                    }}
                  />
                </CheckboxWrapper>
                <CheckboxWrapper>
                  <p className='title'>소모성 :</p>
                  <CheckboxStyled
                    checked={itemData?.is_consumable}
                    onChange={(e) => {
                      onChangeGeneralValue(e.target.checked, 'is_consumable');
                    }}
                  />
                </CheckboxWrapper>
                {itemData?.item_type === 'consumable' && (
                  <CheckboxWrapper>
                    <p className='title'>주 유료 재화 :</p>
                    <CheckboxStyled
                      checked={itemData?.is_prime}
                      onChange={(e) => {
                        onChangeGeneralValue(e.target.checked, 'is_prime');
                      }}
                    />
                  </CheckboxWrapper>
                )}
              </CheckboxSection>
              {/* 연결 리소스. 아이템 타입에 따라 모델 or 미니컷 연결 */}
              <div>
                <p className='title'>
                  {`인게임 리소스 연결 ${
                    itemData.item_type == 'standing'
                      ? '(캐릭터 모델)'
                      : '(미니컷)'
                  }`}
                </p>
                {itemData?.item_type == 'standing' ? (
                  <>
                    <SelectBox
                      value={itemData?.resource_id}
                      onChange={(e) => {
                        onChangeGeneralValue(e, 'resource_id');
                      }}
                      options={dropdownModel?.map((v, i) => {
                        return {
                          value: v.code,
                          label: v.code_name,
                        };
                      })}
                    />
                  </>
                ) : (
                  <>
                    <SelectBox
                      value={itemData?.resource_id}
                      onChange={(e) => {
                        onChangeGeneralValue(e, 'resource_id');
                      }}
                      options={[
                        { value: -1, label: '선택되지 않음' },
                        ...dropdownMinicut?.map((v, i) => {
                          return {
                            value: v.code,
                            label: v.code_name,
                          };
                        }),
                      ]}
                    />
                  </>
                )}
              </div>
              {/* 능력 선택 */}
              <div>
                <p className='title'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.operationContent.editPage.ability',
                  )}
                  :
                </p>
                <SelectBox
                  value={itemData?.ability_id.toString()}
                  onChange={(e) => {
                    onChangeGeneralValue(e, 'ability_id');
                  }}
                  options={dropdownAbility?.map((v, i) => {
                    return {
                      value: v.code,
                      label: v.code_name,
                    };
                  })}
                />
              </div>
              {/* 능력 증감 수치 */}
              <div>
                <p className='title'>능력 증감수치</p>
                <InputStyled
                  value={itemData?.ability_value}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) => {
                    onChangeGeneralValue(e.target.value, 'ability_value');
                  }}
                  type='number'
                />
              </div>
              {/* UI 아이콘 */}
              <div>
                <p className='title'>아이템 UI 아이콘(우편함 등에서 사용)</p>
                <UploadSingleImage
                  targetData={itemData}
                  setTargetData={setItemData}
                  projectId={projectId}
                  image_type='icon'
                  api_target='item'
                />
              </div>
              {/* UI 이미지 */}
              <div>
                <p className='title'>아이템 UI 이미지</p>
                <UploadSingleImage
                  targetData={itemData}
                  setTargetData={setItemData}
                  projectId={projectId}
                  image_type='image'
                  api_target='item'
                />
              </div>
            </LeftSide>

            {/* 오른쪽 구역 */}
            <RightSide>
              <InputWrappingBox>
                <SectionWarpper>
                  {/* 지급 유형(sale_type) */}
                  <div>
                    <p className='edit-heavy-title'>게임내 지급 방식</p>
                    <SelectBox
                      value={itemData.extension?.product_type}
                      onChange={(e) => {
                        onChangeGeneralValue(e, 'product_type');
                      }}
                      options={dropdownSaleType.map((v, i) => {
                        return {
                          value: v.code,
                          label: v.code_name,
                        };
                      })}
                    />
                  </div>
                  {/* 가격 price */}
                  <div>
                    <p className='title'>가격 (**판매 가능한 유형만 표기)</p>
                    <InputStyled
                      value={itemData.extension?.price}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => {
                        onChangeGeneralValue(e.target.value, 'price');
                      }}
                      type='number'
                    />
                  </div>
                  {/* 할인가격 sale_price */}
                  <div>
                    <p className='title'>
                      할인가격 (**실제 UI에 표현되는 가격)
                    </p>
                    <InputStyled
                      value={itemData.extension?.sale_price}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) => {
                        onChangeGeneralValue(e.target.value, 'sale_price');
                      }}
                      type='number'
                    />
                  </div>
                  {/* 할인기간 sale_price */}
                  <div>
                    <p className='title'>할인 기간 (**현재 적용되지 않음)</p>
                    <RangeDatepickerStyled
                      data={itemData}
                      handleDatepickderChange={onChangeDatePicker}
                    />
                  </div>
                  {/* is_public */}
                  <CheckboxSection>
                    <CheckboxWrapper>
                      <p>
                        {t(
                          'storyEpisodeID.storyTabMenuList.operationContent.editPage.salesActivation',
                        )}
                        :
                      </p>
                      <CheckboxStyled
                        checked={itemData.extension?.is_public}
                        onChange={(e) => {
                          onChangeGeneralValue(e.target.checked, 'is_public');
                        }}
                      />
                    </CheckboxWrapper>
                  </CheckboxSection>
                  {/* static_id */}
                  <div>
                    <p className='title'>
                      {t(
                        'storyEpisodeID.storyTabMenuList.operationContent.editPage.connectedBgImage',
                      )}
                      :{' '}
                    </p>
                    <SelectBox
                      value={itemData.extension?.static_id}
                      onChange={(e) => {
                        onChangeGeneralValue(e, 'static_id');
                      }}
                      options={dropdownBG?.map((v, i) => {
                        return {
                          value: v.code,
                          label: v.code_name,
                        };
                      })}
                    />
                  </div>
                </SectionWarpper>
              </InputWrappingBox>
              {/* 오른쪽 입력 부분 끝, 오른쪽 하단 버튼 2개 놓기  */}
              <SubmitFlexBox style={{ columnGap: 12, marginTop: '24px' }}>
                <>
                  <PrimaryButton
                    text={`뒤로가기`}
                    height='40px'
                    width='151px'
                    bgColor='#FFFF'
                    textColor={theme.colors.dark_400}
                    fontWeight={theme.fontWeights.medium}
                    fontSize={theme.fontSizes.normal}
                    border={`1px solid ${theme.colors.gray_6}`}
                    rounded='6px'
                    hoverBgColor={'#FFFF'}
                    activeBgColor={'#FFFF'}
                    selectedBgColor={'#FFFF'}
                    onClick={onClickCancel}
                  />
                  <PrimaryButton
                    text={t('updateStory.form.buttonSubmit')}
                    height='40px'
                    width='151px'
                    bgColor={theme.colors.blue_500}
                    textColor='#ffffff'
                    fontWeight={theme.fontWeights.medium}
                    fontSize={theme.fontSizes.normal}
                    border={`1px solid ${theme.colors.blue_500}`}
                    rounded='6px'
                    hoverBgColor={theme.colors.blue_600}
                    activeBgColor={theme.colors.blue_800}
                    selectedBgColor={theme.colors.blue_700}
                    onClick={submit}
                  />
                </>
              </SubmitFlexBox>
            </RightSide>
            {/* 오른쪽 구역 끝 */}
          </InputFlexBox>
        </Wrapper>
      </DefaultLayout>
    </>
  );
};

export default ItemEdit;

// ! Style
const Wrapper = styled.div`
  & > * + * {
    margin-top: 8rem;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header p {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  .header p span {
    font-weight: ${theme.fontWeights.bold};
  }
  .fixed {
    display: flex;
    align-items: center;
    justify-content: center;
    & > * + * {
      margin-left: 10px;
    }
  }
  .condition {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > * + * {
      margin-left: 16px;
    }
  }
  .length-subtext {
    font-size: ${theme.fontSizes.sm} !important;
    font-style: normal !important;
    font-weight: ${theme.fontWeights.normal} !important;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  row-gap: 24px;
  margin-right: 1.5rem;

  border: 1px solid #bcbec0;
  padding: 1.5rem 1.5rem;
  border-radius: 8px;
  & > * + * {
    margin-top: 16px;
  }
`;
const RightSide = styled.div`
  width: 100%;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 24px;
  }
  .ant-input-disabled {
    color: ${theme.colors.dark_300};
  }
`;

const CheckboxStyled = styled(Checkbox)`
  .ant-checkbox .ant-checkbox-input {
    cursor: default;
  }
  .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    border: 1px solid #d9d9d9;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 1rem;
  }
`;

const CheckboxSection = styled.div`
  display: flex;
  & > * + * {
    margin-left: 24px;
  }
`;

const OtomeProjectContentWrapper = styled.div`
  border: 1px solid #bcbec0;
  padding: 1.5rem 1.5rem;
  border-radius: 8px;
  & > * + * {
    margin-top: 16px;
  }
`;
